import { type StatusType } from "ui/status";

import { TouchpointBatchDTOStatus } from "generated/schemas/touchpoint-batch-dto-status";
import { TouchpointStatuses } from "types";

export const getStatusType = (status?: string): StatusType => {
  switch (status) {
    case TouchpointStatuses.CLIENT_REVIEW:
    case TouchpointStatuses.IN_REVIEW:
      return "in-review";
    case TouchpointStatuses.REJECTED:
    case TouchpointStatuses.SYSTEM_DRAFT:
      return "feedback-received";
    case TouchpointStatuses.APPROVED:
    case TouchpointStatuses.PUBLISHED:
      return "approved";
    case TouchpointStatuses.ARCHIVED:
    case TouchpointStatuses.ARCHIVED_CLIENT_REVIEW:
    case TouchpointStatuses.ARCHIVED_DRAFT:
      return "archived";
    case TouchpointBatchDTOStatus.BUILDING:
      return "building";
    default:
      return "not-reviewed-yet";
  }
};
